/**
 * Labstep
 *
 * @module core/Form/Reusable/Label
 * @desc Field label for reusable form
 */

import { Icon } from 'labstep-web/core/Icon';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import styles from './styles.module.scss';
import type { IFormReusableLabelProps } from './types';

export const FormReusableLabel: React.FC<IFormReusableLabelProps> = ({
  fieldLabel,
  fieldExplainer,
}) => (
  <div className={styles.labelContainer}>
    <label>{fieldLabel}</label>
    {fieldExplainer && (
      <Popup
        inverted
        content={fieldExplainer}
        trigger={<Icon name="question circle outline" />}
      />
    )}
  </div>
);
